import React from "react";
import { FolderOpen } from "lucide-react";
import FilterDropdown from "./FilterDropdown";

// Same look/behavior as the project dropdown on Usage History
// (src/pages/superAdmin/UsageHistory.jsx) — reused so filters stay consistent
// across super-admin list pages.
const ProjectFilterDropdown = ({ projects, value, onChange, allLabel = "All Projects", allValue = "all" }) => {
  const options = [
    { value: allValue, label: allLabel },
    ...projects.map((p) => ({ value: p.projectPid, label: p.projectName })),
  ];

  return <FilterDropdown options={options} value={value} onChange={onChange} icon={FolderOpen} />;
};

export default ProjectFilterDropdown;
